export default __webpack_public_path__ + "static/logo-1cdbb1dc9c89549a91f264ee1b37aa7f.svg";